import React from 'react';
import { FaMusic } from 'react-icons/fa';
import { useAudio } from '../contexts/AudioContext';

const AudioControl = ({ className = '' }) => {
  const { isPlaying, toggleAudio } = useAudio();

  return (
    <button
      onClick={toggleAudio}
      className={`text-xl transition-colors ${isPlaying ? 'text-rose-600' : 'text-gray-400'} ${className}`}
      aria-label={isPlaying ? 'Pausar música' : 'Reproducir música'}
    >
      <FaMusic />
    </button>
  );
};

export default AudioControl;
